/**
 * Defines the type {@linkcode FormConfig} used for passing the form
 * configuration to the form renderer, as well as related types.
 *
 * @packageDocumentation
 */
export var FreeFormAddressElementType;
(function (FreeFormAddressElementType) {
    FreeFormAddressElementType["Element3"] = "element3";
    FreeFormAddressElementType["Element4"] = "element4";
    FreeFormAddressElementType["Element5"] = "element5";
    FreeFormAddressElementType["Element6"] = "element6";
    FreeFormAddressElementType["Element7"] = "element7";
    FreeFormAddressElementType["Element8"] = "element8";
    FreeFormAddressElementType["Element9"] = "element9";
    FreeFormAddressElementType["Element10"] = "element10";
    FreeFormAddressElementType["Element11"] = "element11";
    FreeFormAddressElementType["Element12"] = "element12";
    FreeFormAddressElementType["Element13"] = "element13";
    FreeFormAddressElementType["Element14"] = "element14";
    FreeFormAddressElementType["Element15"] = "element15";
})(FreeFormAddressElementType || (FreeFormAddressElementType = {}));
export var ValidationKind;
(function (ValidationKind) {
    ValidationKind["Expression"] = "Expression";
    ValidationKind["Luhn"] = "Luhn";
    ValidationKind["CVC"] = "CVC";
    ValidationKind["MinimumAge"] = "MinimumAge";
    ValidationKind["SoonExpiration"] = "SoonExpiration";
    ValidationKind["ValidDate"] = "ValidDate";
    ValidationKind["IBAN"] = "IBAN";
    ValidationKind["Unsupported"] = "Unsupported";
})(ValidationKind || (ValidationKind = {}));
export var SocialNetworkType;
(function (SocialNetworkType) {
    SocialNetworkType["Linkedin"] = "Linkedin";
    SocialNetworkType["Twitter"] = "Twitter";
    SocialNetworkType["Instagram"] = "Instagram";
    SocialNetworkType["Facebook"] = "Facebook";
})(SocialNetworkType || (SocialNetworkType = {}));
//# sourceMappingURL=form.js.map